module.exports = __webpack_public_path__ + "static/media/chrome.99f0b30c.svg";